import React, { useState } from 'react';
import { ItemType, MoodboardItem } from '../types/moodboard';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from './ui/dialog';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Plus } from 'lucide-react';
interface AddItemDialogProps {
  onAdd: (item: Omit<MoodboardItem, 'id' | 'createdAt'>) => void;
}
export function AddItemDialog({
  onAdd
}: AddItemDialogProps) {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState<ItemType>('image');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [description, setDescription] = useState('');
  const [tagsInput, setTagsInput] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim()) return;
    const tags = tagsInput.split(',').map(t => t.trim().toUpperCase()).filter(t => t.length > 0);
    onAdd({
      type,
      title: title.trim().toUpperCase(),
      content: content.trim(),
      description: description.trim(),
      tags
    });
    setType('image');
    setTitle('');
    setContent('');
    setDescription('');
    setTagsInput('');
    setOpen(false);
  };
  const getContentLabel = () => {
    switch (type) {
      case 'image':
        return 'URL IMMAGINE';
      case 'link':
        return 'URL SITO WEB';
      case 'note':
        return 'TESTO DELLA NOTA';
      case 'color_palette':
        return 'COLORI (HEX, SEPARATI DA VIRGOLA)';
      default:
        return 'CONTENUTO';
    }
  };
  return <Dialog open={open} onOpenChange={setOpen} data-id="element-34">
      <DialogTrigger asChild data-id="element-35">
        <button className="text-[#999] hover:text-black transition-colors" aria-label="Nuovo Elemento" data-id="element-36">
          <Plus className="w-[18px] h-[18px]" strokeWidth={1.5} data-id="element-37" />
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[480px] bg-white border border-border rounded-none p-0 shadow-none w-[calc(100%-2rem)] mx-auto" data-id="element-38">
        <DialogHeader className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4 sm:pb-6 border-b border-border" data-id="element-39">
          <DialogTitle className="font-heading font-light text-[14px] tracking-[0.25em] uppercase" data-id="element-40">
            AGGIUNGI ELEMENTO
          </DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="px-6 sm:px-8 py-6 space-y-6" data-id="element-41">
          <div className="space-y-2" data-id="element-42">
            <label className="font-heading text-[10px] tracking-[0.2em] uppercase text-[#666]" data-id="element-43">
              TIPO
            </label>
            <Select value={type} onValueChange={v => setType(v as ItemType)} data-id="element-44">
              <SelectTrigger className="rounded-none border-border bg-white text-[12px] font-sans h-10" data-id="element-45">
                <SelectValue data-id="element-46" />
              </SelectTrigger>
              <SelectContent className="rounded-none border-border bg-white" data-id="element-47">
                <SelectItem value="image" className="text-[12px] font-sans" data-id="element-48">
                  Immagine
                </SelectItem>
                <SelectItem value="note" className="text-[12px] font-sans" data-id="element-49">
                  Nota
                </SelectItem>
                <SelectItem value="color_palette" className="text-[12px] font-sans" data-id="element-50">
                  Palette Colori
                </SelectItem>
                <SelectItem value="link" className="text-[12px] font-sans" data-id="element-51">
                  Link
                </SelectItem>
              </SelectContent>
            </Select>
          </div>

          {type !== 'note' && <div className="space-y-2" data-id="element-52">
              <label className="font-heading text-[10px] tracking-[0.2em] uppercase text-[#666]" data-id="element-53">
                TITOLO
              </label>
              <Input value={title} onChange={e => setTitle(e.target.value)} className="rounded-none border-border bg-white text-[13px] font-sans h-10" data-id="element-54" />
            </div>}

          <div className="space-y-2" data-id="element-55">
            <label className="font-heading text-[10px] tracking-[0.2em] uppercase text-[#666]" data-id="element-56">
              {getContentLabel()} *
            </label>
            {type === 'note' ? <Textarea value={content} onChange={e => setContent(e.target.value)} required className="min-h-[100px] rounded-none border-border bg-white text-[13px] font-sans" data-id="element-57" /> : <Input value={content} onChange={e => setContent(e.target.value)} required className="rounded-none border-border bg-white text-[13px] font-sans h-10" data-id="element-58" />}
          </div>

          {type !== 'note' && <div className="space-y-2" data-id="element-59">
              <label className="font-heading text-[10px] tracking-[0.2em] uppercase text-[#666]" data-id="element-60">
                DESCRIZIONE
              </label>
              <Textarea value={description} onChange={e => setDescription(e.target.value)} className="h-20 rounded-none border-border bg-white text-[13px] font-sans" data-id="element-61" />
            </div>}

          <div className="space-y-2" data-id="element-62">
            <label className="font-heading text-[10px] tracking-[0.2em] uppercase text-[#666]" data-id="element-63">
              TAG (SEPARATI DA VIRGOLA)
            </label>
            <Input value={tagsInput} onChange={e => setTagsInput(e.target.value)} className="rounded-none border-border bg-white text-[13px] font-sans h-10" data-id="element-64" />
          </div>

          <DialogFooter className="pt-6 border-t border-border flex gap-4" data-id="element-65">
            <button type="button" onClick={() => setOpen(false)} className="font-heading text-[11px] tracking-[0.15em] uppercase text-[#666] hover:text-black transition-colors" data-id="element-66">
              ANNULLA
            </button>
            <button type="submit" disabled={!content.trim()} className="font-heading text-[11px] tracking-[0.15em] uppercase text-black border-b border-black pb-0.5 hover:opacity-60 transition-opacity disabled:opacity-30" data-id="element-67">
              AGGIUNGI ALLA BOARD
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>;
}